import React from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { SUPPORTED_CURRENCIES } from "../../../Services/exchanges/ExchangeService";
import { QUARTER_TABS } from "./ExchangeListHelpers";

export default function ExchangeRateModal({
  isOpen,
  toggle,
  isAdding,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  periodYear,
  onPeriodYearChange,
  onApplyQuarter,
  rateRows,
  onRateRowChange,
  onAddRateRow,
  onRemoveRateRow,
  onSubmit,
  isSaving,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered className="ex-modal">
      <ModalHeader toggle={toggle}>
        {isAdding ? "Add exchange rate period" : "Edit exchange rate period"}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <div className="ex-modal__section">
            <h6 className="ex-modal__heading">Validity period</h6>
            <p className="ex-modal__hint">Pick a quarter preset or set custom dates.</p>

            <div className="ex-quarter-picker">
              <FormGroup className="ex-quarter-picker__year">
                <Label for="period_year">Year</Label>
                <Input
                  id="period_year"
                  type="number"
                  min="2000"
                  max="2100"
                  value={periodYear}
                  onChange={(e) => onPeriodYearChange(Number(e.target.value))}
                />
              </FormGroup>
              <div className="ex-quarter-picker__tabs">
                {QUARTER_TABS.filter((tab) => tab.id !== "all").map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className="ex-quarter-picker__btn"
                    onClick={() => onApplyQuarter(tab.id, periodYear)}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            <Row className="mt-2">
              <Col md="6">
                <FormGroup>
                  <Label for="start_date">Start date</Label>
                  <DatePicker
                    selected={startDate}
                    onChange={onStartDateChange}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    wrapperClassName="w-100"
                    placeholderText="YYYY-MM-DD"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label for="end_date">End date</Label>
                  <DatePicker
                    selected={endDate}
                    onChange={onEndDateChange}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    wrapperClassName="w-100"
                    placeholderText="YYYY-MM-DD"
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div className="ex-modal__section">
            <h6 className="ex-modal__heading">Currency rates</h6>
            <p className="ex-modal__hint">Add one row per currency. Rates must be positive numbers.</p>
            {rateRows.map((row, index) => (
              <Row className="ex-modal__rate-row align-items-end" key={`rate-row-${index}`}>
                <Col md="5">
                  <FormGroup>
                    <Label>Currency</Label>
                    <Input
                      type="select"
                      value={row.currency}
                      onChange={(e) => onRateRowChange(index, "currency", e.target.value)}
                    >
                      {SUPPORTED_CURRENCIES.map((currency) => (
                        <option key={currency} value={currency}>
                          {currency}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="5">
                  <FormGroup>
                    <Label>Rate</Label>
                    <Input
                      type="text"
                      inputMode="decimal"
                      className="ex-modal__rate-input"
                      value={row.value}
                      onChange={(e) => onRateRowChange(index, "value", e.target.value)}
                      placeholder="3.30"
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <Button
                    type="button"
                    color="light"
                    className="ex-modal__remove"
                    onClick={() => onRemoveRateRow(index)}
                    title="Remove currency"
                  >
                    <i className="fa fa-trash" />
                  </Button>
                </Col>
              </Row>
            ))}
            <Button type="button" color="light" className="ex-modal__add-row" onClick={onAddRateRow}>
              <i className="fa fa-plus me-1" />
              Add currency
            </Button>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={isSaving}>
            {isSaving ? "Saving…" : isAdding ? "Save period" : "Update period"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
